import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router';

import {
  AuthTemplate,
  FooterLinks,
} from '@/pages/unauthenticated/auth/components';

export default function CliSuccessPage() {
  const [searchParams] = useSearchParams();
  const cli = searchParams.get('cli') ?? '';

  // Replace the URL with params with a clean URL: "/cli/success"
  useEffect(() => {
    if (!cli) return;
    window.history.replaceState(
      { ...window.history.state, as: '/cli/success', url: '/cli/success' },
      '',
      '/cli/success',
    );
  }, [cli]);

  if (!cli) {
    return <Navigate to="/" replace />;
  }
  return (
    <AuthTemplate heading="Login Successful" footer={<FooterLinks />}>
      <span className="text-sm">
        You can close this window and return to the terminal.
      </span>
    </AuthTemplate>
  );
}
